import { basicSearchTravelClient } from "@/utils/basicSearchTravelClient";
import type { SearchData } from "front-search-schema/algolia";

export const searchTravelClient = async (term: string, fitOnly = false): Promise<SearchData> => {
  const data = await basicSearchTravelClient({
    q: term,
    filter: [[fitOnly ? "isFitTemplate:true" : "hasDepartures:true"]],
  });

  return data;
};
